import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import checkRedBackground from 'public/static/images/check-red-background.svg';
import checkRedFill from 'public/static/images/check-red-fill.svg';

const styles = css`
  .checkbox {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
  .checkbox:hover {
    cursor: pointer;
  }
  .checkbox-unchecked {
    width: 24px;
    height: 24px;
    border: solid ${colors.BLACK} 1px;
  }
  @media (hover: hover) and (pointer: fine) {
    .checkbox-unchecked:hover {
      background-image: url(${checkRedFill});
      background-size: cover;
    }
  }
  .checkbox-checked {
    background-color: ${colors.ALR1};
    background-image: url(${checkRedBackground});
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
export default styles;
